import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pinnedItems: [], // Array of pinned menu items
  maxPinnedItems: 5, // Maximum number of pinned items to show in bottom bar
};

const pinnedMenuSlice = createSlice({
  name: "pinnedMenu",
  initialState,
  reducers: {
    _pinMenuItem: (state, action) => {
      const itemToPin = action.payload;
      
      // Check if item is already pinned
      const isAlreadyPinned = state.pinnedItems.some(
        item => item.path === itemToPin.path && item.label === itemToPin.label
      );
      
      if (!isAlreadyPinned) {
        // Add timestamp for ordering
        const pinnedItem = {
          ...itemToPin,
          pinnedAt: Date.now(),
        };
        
        state.pinnedItems.push(pinnedItem);
      }
    },
    
    _unpinMenuItem: (state, action) => {
      const { path, label } = action.payload;
      state.pinnedItems = state.pinnedItems.filter(
        item => !(item.path === path && item.label === label)
      );
    },
    
    _reorderPinnedItems: (state, action) => {
      state.pinnedItems = action.payload;
    },
    
    _clearAllPinnedItems: (state) => {
      state.pinnedItems = [];
    },
  },
});

export const {
  _pinMenuItem,
  _unpinMenuItem,
  _reorderPinnedItems,
  _clearAllPinnedItems,
} = pinnedMenuSlice.actions;

export default pinnedMenuSlice.reducer;
